import { render, staticRenderFns } from "./EditarRecordatorio.vue?vue&type=template&id=3604740c&scoped=true"
import script from "./EditarRecordatorio.vue?vue&type=script&lang=js"
export * from "./EditarRecordatorio.vue?vue&type=script&lang=js"
import style0 from "./EditarRecordatorio.vue?vue&type=style&index=0&id=3604740c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604740c",
  null
  
)

export default component.exports